import authActions from "./actions";

const initialState = {
  candidateTokenDetails:null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authActions.CANDIDATE_LOGIN:
      return{
        ...state,
        candidateTokenDetails:action.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
